<template>
  <div>
    <v-dialog v-model="dialog_detail_state" max-width="90%">
      <app-card>
        <app-section-loader :status="form_loader"></app-section-loader>
        <h4>PHIẾU CHI TIẾT {{ wallet_account.toUpperCase() }}</h4>
        <p class="fs-14 grey--text mb-1">
          Mã giao dịch hiện tại:
          <strong>{{ transaction.bank_receipt_id }}</strong>
        </p>
        <p class="fs-14 grey--text mb-1">
          Ngày:
          <strong>{{ transaction.date_action | formatTimeServer }}</strong>
        </p>
        <p class="fs-14 grey--text mb-1">
          Số dư giao dịch NH:
          <strong>{{ transaction.balance | formatCurrency }}</strong>
        </p>
        <p class="fs-14 grey--text mb-1">
          Tổng số tiền các phiếu:
          <strong>{{ totalReceiptAmount | formatCurrency }}</strong>
        </p>
        <p class="fs-14 grey--text mb-1">
          Tổng các phiếu:
          <strong>{{ totalReceiptCount }}</strong>
        </p>
        <p class="fs-14 grey--text mb-1">
          Nội dung chi tiết:
          <strong>{{ transaction.description }}</strong>
        </p>
        <v-stepper v-model="current_step">
          <v-stepper-header style="box-shadow: none">
            <v-stepper-step :complete="current_step > 1" step="1"
              >Tạo phiếu chi tiết</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step :complete="current_step > 2" step="2"
              >Tóm tắt</v-stepper-step
            >
          </v-stepper-header>
          <hr class="mt-0" />
          <v-stepper-items>
            <v-stepper-content step="1">
              <app-section-loader :status="loader"></app-section-loader>
              <v-form ref="form">
                <h4>
                  <v-flex xs12>
                    <v-btn
                      :loading="loading.submit"
                      :disabled="loading.submit"
                      @click="addReceipt(RECEIPT_TYPE.DISBURSEMENT)"
                      flat
                      color="primary"
                    >
                      Thêm phiếu chi
                      <v-icon right dark>add</v-icon>
                    </v-btn>
                  </v-flex>
                </h4>
                <v-layout
                  row
                  wrap
                  v-for="(receipt, index) in this
                    .receipt_disbursement_list_state"
                  :key="'disbursement-' + (receipt.receipt_id || receipt.local_id)"
                >
                  <v-flex xs12 md12>
                    <card-tao-phieu-chi-tu-giao-dich
                      @setReceiptListState="
                        (receipt, index) => {
                          setReceiptListState(
                            RECEIPT_TYPE.DISBURSEMENT,
                            receipt,
                            index
                          );
                        }
                      "
                      @removeReceipt="
                        (receiptIndex) =>
                          removeReceipt(RECEIPT_TYPE.DISBURSEMENT, receiptIndex)
                      "
                      :receipt="receipt"
                      :index="index"
                      :transaction="transaction"
                      :totalReceiptCount="totalReceiptCount"
                      :totalReceiptIndex="getReceiptIndex(receipt, index)"
                    />
                  </v-flex>
                </v-layout>
                <h4 class="border-top">
                  <v-flex xs12>
                    <v-btn
                      :loading="loading.submit"
                      :disabled="loading.submit"
                      @click="addReceipt(RECEIPT_TYPE.INCOME)"
                      flat
                      color="primary"
                    >
                      Thêm phiếu thu
                      <v-icon right dark>add</v-icon>
                    </v-btn>
                  </v-flex>
                </h4>
                <v-layout
                  row
                  wrap
                  v-for="(receipt, index) in this.receipt_income_list_state"
                  :key="'income-' + (receipt.receipt_id || receipt.local_id)"
                >
                  <v-flex xs12 md12>
                    <card-tao-phieu-thu-tu-giao-dich
                      @setReceiptListState="
                        (receipt, index) => {
                          setReceiptListState(
                            RECEIPT_TYPE.INCOME,
                            receipt,
                            index
                          );
                        }
                      "
                      @removeReceipt="
                        (receiptIndex) =>
                          removeReceipt(RECEIPT_TYPE.INCOME, receiptIndex)
                      "
                      :receipt="receipt"
                      :transaction="transaction"
                      :index="index"
                      :totalReceiptCount="totalReceiptCount"
                      :totalReceiptIndex="getReceiptIndex(receipt, index)"
                    ></card-tao-phieu-thu-tu-giao-dich> </v-flex
                ></v-layout>
              </v-form>
              <v-card-actions class="mt-5 mb-3">
                <v-spacer></v-spacer>
                <v-btn
                  outline
                  :loading="loading.submit"
                  :disabled="loading.submit"
                  @click="goBack"
                  color="primary"
                >
                  Trở về
                </v-btn>
                <v-btn
                  v-if="true"
                  :disabled="loading.submit || form_loader"
                  :loading="loading.submit || form_loader"
                  @click="handleNextStep"
                  color="primary"
                >
                  Lưu
                </v-btn>
              </v-card-actions>
            </v-stepper-content>
            <v-stepper-content v-if="current_step == 2" step="2">
              <v-container grid-list-xs>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Diễn giải thay đổi"
                      :disabled="loading.submit"
                      v-model="receipt_disbursement_list[index].note"
                      prepend-icon="event_note"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 v-if="role === 'admin'">
                    <v-text-field
                      label="computed_note (admin only)"
                      :disabled="loading.submit"
                      v-model="receipt_disbursement_list[index].computed_note"
                      prepend-icon="event_note"
                    >
                    </v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12>
                    <change-detail :change_data="receipt_disbursement_list"></change-detail>
                  </v-flex> -->
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  outline
                  :loading="loading.submit"
                  :disabled="loading.submit"
                  @click="goBack"
                  color="primary"
                >
                  Trở về
                </v-btn>
                <v-btn
                  v-if="receipt_disbursement_list[index].room_state_id"
                  :loading="loading.submit"
                  :disabled="loading.submit"
                  @click="submit"
                  color="primary"
                >
                  Tạo Phiếu
                </v-btn>
              </v-card-actions>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </app-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "Api";
import { formatCurrency, formatTimeServer, parseCurrency } from "Helpers";
import {
  list_building,
  EXPENSE_ACCOUNT_OPTIONS,
  ACCOUNT_TYPES,
  WALLET_ID_AND_ACCOUNT_TYPE_MAP,
} from "Constants/db-config";
import CardTaoPhieuChiTuGiaoDich from "./ReceiptDisbursement.vue";
import CardTaoPhieuThuTuGiaoDich from "./ReceiptIncome.vue";

const EMPTY_DISBURSEMENT_FORM = {
  receipt_id: "",
  date_created: "",
  amount: "",
  type: "",
  wallet_account_id: null,
  note: "",
  building: "",
  room_id: "",
  check_out_id: "",
  loan_object: "",
  salary_recipient: "",
  land_rent_location: "",
  material_purchase_type: "",
  repair_expense_type: "",
  loan_interest_object: "",
};

const EMPTY_RECEIPT_INCOME_FORM = {
  receipt_id: "",
  building: "",
  room_id: "",
  date_collected: "",
  note: "",
  room_state_id: "",
  collector: "",
  month: "",
  collected_amount: "",
  wallet_account_id: null,
  receipt_type: "",
  loan_object: "",
  primary_amount: "",
  has_supplementary_receipt: false,
  supplementary_amount: "",
};

const RECEIPT_TYPE = {
  DISBURSEMENT: "DISBURSEMENT",
  INCOME: "INCOME",
};

export default {
  props: ["dialogDetail", "transaction"],
  name: "dialog-tao-phieu-chi-tiet-so-tien-ngan-hang",
  components: {
    CardTaoPhieuChiTuGiaoDich,
    CardTaoPhieuThuTuGiaoDich,
  },
  data() {
    const wallet_account =
      WALLET_ID_AND_ACCOUNT_TYPE_MAP[this.transaction.wallet_account_id];

    return {
      delete_disbursement_receipt_ids: [],
      delete_receipt_room_ids: [],
      delete_receipt_other_ids: [],
      delete_receipt_deposit_ids: [],
      delete_receipt_loan_ids: [],
      delete_receipt_gam_ids: [],
      delete_mr_long_receipt_ids: [],
      delete_additional_deposit_receipt_ids: [],
      delete_receipt_undistributed_earning_ids: [],
      dialog_detail_state: this.dialogDetail,
      form_loader: false,
      receipt_disbursement_list_state: [],
      receipt_disbursement_list: [],
      receipt_income_list_state: [],
      receipt_income_list: [],
      menu_date_change: false,
      list_building,
      RECEIPT_TYPE,
      EXPENSE_ACCOUNT_OPTIONS,
      alert: {
        show: false,
        text: "",
        type: "error",
      },
      chosen_room_contract: null,
      current_step: 1,
      loading: {
        submit: false,
      },
      loader: false,
      wallet_account,
    };
  },
  watch: {
    dialogDetail(nv) {
      this.dialog_detail_state = nv;
    },
    dialog_detail_state(nv) {
      this.$emit("update:dialogDetail", nv);
    },
    transaction(newTransaction) {
      this.updateReceiptListData();
    },
  },
  computed: {
    rooms() {
      return this.$store.state.app.rooms;
    },
    role() {
      return this.$store.state.auth.role;
    },
    totalReceiptCount() {
      return (
        this.receipt_income_list_state.length +
        this.receipt_disbursement_list_state.length
      );
    },
    totalReceiptAmount() {
      return (
        this.receipt_income_list_state.reduce(
          (acc, currentReceipt) =>
            acc +
            (parseCurrency(currentReceipt.collected_amount) ||
              parseCurrency(currentReceipt.deposit_amount) ||
              0),
          0
        ) -
        this.receipt_disbursement_list_state.reduce(
          (acc, currentReceipt) =>
            acc + (parseCurrency(currentReceipt.amount) || 0),
          0
        )
      );
    },
  },
  mounted() {
    this.updateReceiptListData();
  },
  methods: {
    updateReceiptListData() {
      if (this.transaction && this.transaction.date_action) {
        // EMPTY_DISBURSEMENT_FORM
        EMPTY_DISBURSEMENT_FORM.date_created = formatTimeServer(
          this.transaction.date_action,
          "YYYY-MM-DD"
        );

        EMPTY_DISBURSEMENT_FORM.wallet_account_id = this.transaction.wallet_account_id;

        // EMPTY_RECEIPT_INCOME_FORM
        EMPTY_RECEIPT_INCOME_FORM.date_collected = formatTimeServer(
          this.transaction.date_action,
          "YYYY-MM-DD"
        );

        EMPTY_RECEIPT_INCOME_FORM.month = formatTimeServer(
          this.transaction.date_action,
          "YYYY-MM"
        );
        EMPTY_RECEIPT_INCOME_FORM.wallet_account_id = this.transaction.wallet_account_id;
      }

      this.receipt_disbursement_list = this.transaction.receipt_disbursements.map(
        (receipt) => {
          return {
            ...receipt,
            isEdit: true,
            amount: formatCurrency(receipt.amount),
            date_created: formatTimeServer(receipt.date_created, "YYYY-MM-DD"),
            wallet_account_id: this.transaction.wallet_account_id,
          };
        }
      );

      this.receipt_disbursement_list_state = [
        ...this.receipt_disbursement_list,
      ];

      this.receipt_income_list = [
        ...this.transaction.receipt_rooms,
        ...this.transaction.receipt_others,
      ].map((receipt) => {
        return {
          ...receipt,
          isEdit: true,
          date_collected: formatTimeServer(
            receipt.date_collected,
            "YYYY-MM-DD"
          ),
          wallet_account_id: this.transaction.wallet_account_id,
          month: formatTimeServer(receipt.month || receipt.date_collected, "YYYY-MM"),
          collected_amount: formatCurrency(receipt.collected_amount),
        };
      });

      this.receipt_income_list = [
        ...this.receipt_income_list,
        ...this.transaction.receipt_deposits.map((receipt) => {
          return {
            ...receipt,
            agent: { user_id: receipt.agent_id, name: receipt.agent_name },
            isEdit: true,
            date_schedule_in: formatTimeServer(receipt.date_deposit, "YYYY-MM-DD"),
            date_deposit: formatTimeServer(receipt.date_deposit, "YYYY-MM-DD"),
            wallet_account_id: this.transaction.wallet_account_id,
            deposit_amount: formatCurrency(receipt.deposit_amount),
            room_price: formatCurrency(receipt.room_price),
          };
        }),
      ];
      this.receipt_income_list = [
        ...this.receipt_income_list,
        ...this.transaction.receipt_cashes.map((receipt) => {
          return {
            ...receipt,
            isEdit: receipt.bank_transaction_id ? false: true,
            date_collected: formatTimeServer(receipt.date_collected, "YYYY-MM-DD"),
            wallet_account_id: receipt.wallet_account_id,
            collected_amount: formatCurrency(receipt.amount),
          };
        }),
      ];

      this.receipt_income_list = [
        ...this.receipt_income_list,
        ...this.transaction.receipt_loans.map((receipt) => {
          return {
            ...receipt,
            isEdit: true,
            date_collected: formatTimeServer(
              receipt.date_collected,
              "YYYY-MM-DD"
            ),
            wallet_account_id: this.transaction.wallet_account_id,
            month: formatTimeServer(receipt.month || receipt.date_collected, "YYYY-MM"),
            collected_amount: formatCurrency(receipt.collected_amount),
          };
        })
      ];

      this.receipt_income_list = [
        ...this.receipt_income_list,
        ...this.transaction.receipt_gams.map((receipt) => {
          return {
            ...receipt,
            isEdit: true,
            date_collected: formatTimeServer(
              receipt.date_collected,
              "YYYY-MM-DD"
            ),
            wallet_account_id: this.transaction.wallet_account_id,
            month: formatTimeServer(receipt.month || receipt.date_collected, "YYYY-MM"),
            collected_amount: formatCurrency(receipt.collected_amount),
          };
        })
      ];

      this.receipt_income_list = [
        ...this.receipt_income_list,
        ...this.transaction.additional_deposit_receipts.map((receipt) => {
          return {
            ...receipt,
            isEdit: true,
            date_collected: formatTimeServer(
              receipt.date_collected,
              "YYYY-MM-DD"
            ),
            wallet_account_id: this.transaction.wallet_account_id,
            month: formatTimeServer(receipt.month || receipt.date_collected, "YYYY-MM"),
            collected_amount: formatCurrency(receipt.collected_amount),
          };
        })
      ];

      this.receipt_income_list = [
        ...this.receipt_income_list,
        ...this.transaction.mr_long_receipts.map((receipt) => {
          return {
            ...receipt,
            isEdit: true,
            date_collected: formatTimeServer(
              receipt.date_collected,
              "YYYY-MM-DD"
            ),
            wallet_account_id: this.transaction.wallet_account_id,
            month: formatTimeServer(receipt.month || receipt.date_collected, "YYYY-MM"),
            collected_amount: formatCurrency(receipt.collected_amount),
          };
        })
      ];

      this.receipt_income_list = [
        ...this.receipt_income_list,
        ...this.transaction.receipt_undistributed_earnings.map((receipt) => {
          return {
            ...receipt,
            isEdit: true,
            date_collected: formatTimeServer(
              receipt.date_collected,
              "YYYY-MM-DD"
            ),
            wallet_account_id: this.transaction.wallet_account_id,
            month: formatTimeServer(receipt.month || receipt.date_collected, "YYYY-MM"),
            collected_amount: formatCurrency(receipt.collected_amount),
          };
        })
      ];

      // Ghi nhớ loại thu và mã phiếu GỐC của các phiếu đã lưu.
      // Mỗi loại thu nằm ở một collection riêng, nên khi người dùng đổi loại phiếu
      // thì phải xoá bản ghi ở collection CŨ rồi tạo mới ở collection MỚI. Trước đây
      // FE gửi thẳng _id/mã phiếu sang API của loại mới -> sửa thì báo "không tìm thấy
      // phiếu thu", xoá thì im lặng không xoá được, và tạo thêm bản mới => giao dịch
      // lệch tiền (NT-250).
      this.receipt_income_list = this.receipt_income_list.map((receipt) => ({
        ...receipt,
        original_receipt_type: receipt.receipt_type,
        original_receipt_id: receipt.receipt_id,
      }));

      this.receipt_income_list_state = [...this.receipt_income_list];
    },
    getReceiptIndex(receipt, index) {
      if (receipt.receipt_index) return receipt.receipt_index;
      if (receipt.receipt_id && receipt.receipt_id.startsWith(this.transaction.bank_receipt_id + ".")) {
         const suffix = receipt.receipt_id.substring(this.transaction.bank_receipt_id.length + 1);
         const num = parseInt(suffix.split(".")[0], 10);
         if (!isNaN(num)) return num;
      }
      return index + 1;
    },
    getNextReceiptIndex: function() {
      let maxIndex = 0;
      const allReceipts = [
        ...this.receipt_income_list_state,
        ...this.receipt_disbursement_list_state,
      ];

      allReceipts.forEach((r) => {
        if (r.receipt_index) {
          maxIndex = Math.max(maxIndex, r.receipt_index);
        } else if (r.receipt_id && r.receipt_id.startsWith(this.transaction.bank_receipt_id + ".")) {
          const suffix = r.receipt_id.substring(this.transaction.bank_receipt_id.length + 1);
          const indexPart = suffix.split(".")[0];
          const num = parseInt(indexPart, 10);
          if (!isNaN(num)) maxIndex = Math.max(maxIndex, num);
        }
      });
      return maxIndex + 1;
    },
    addReceipt(receipt_type) {
      const nextIndex = this.getNextReceiptIndex();
      switch (receipt_type) {
        case this.RECEIPT_TYPE.DISBURSEMENT: {
          this.receipt_disbursement_list_state.push({
            ...EMPTY_DISBURSEMENT_FORM,
            local_id: Date.now() + Math.random(),
            receipt_index: nextIndex,
          });
          break;
        }
        case this.RECEIPT_TYPE.INCOME: {
          this.receipt_income_list_state.push({
            ...EMPTY_RECEIPT_INCOME_FORM,
            local_id: Date.now() + Math.random(),
            receipt_index: nextIndex,
          });
          break;
        }
        default:
          throw new Error("Wrong receipt_type in addReceipt");
      }
    },
    goBack: function() {
      if (this.current_step === 2) this.current_step = 1;
      else {
        this.dialog = false;
        this.$emit("update:dialogDetail", false);
      }
    },
    // Mỗi loại thu nằm ở một collection riêng, nên mỗi loại có một delete-list riêng.
    // Trả về false nếu không nhận diện được loại thu.
    pushDeleteReceiptId: function(income_type, receipt_id) {
      const delete_list_by_type = {
        [ACCOUNT_TYPES.RECEIPT_OTHER]: this.delete_receipt_other_ids,
        [ACCOUNT_TYPES.RECEIPT_ROOM]: this.delete_receipt_room_ids,
        receipt_deposit: this.delete_receipt_deposit_ids,
        receipt_loan: this.delete_receipt_loan_ids,
        receipt_gam: this.delete_receipt_gam_ids,
        additional_deposit_receipt: this.delete_additional_deposit_receipt_ids,
        mr_long_receipt: this.delete_mr_long_receipt_ids,
        receipt_undistributed_earning: this
          .delete_receipt_undistributed_earning_ids,
      };

      const delete_list = delete_list_by_type[income_type];

      if (!delete_list) return false;

      delete_list.push(receipt_id);
      return true;
    },
    removeReceipt: function(receipt_type, index) {
      switch (receipt_type) {
        case RECEIPT_TYPE.INCOME: {
          const receipt = this.receipt_income_list_state[index];

          if (receipt.isEdit) {
            // Phiếu đã lưu có thể vừa bị đổi loại trong dialog -> phải xoá theo
            // loại GỐC và mã GỐC, vì bản ghi nằm ở collection của loại gốc.
            const removed = this.pushDeleteReceiptId(
              receipt.original_receipt_type || receipt.receipt_type,
              receipt.original_receipt_id || receipt.receipt_id
            );

            if (!removed) {
              throw new Error("Wrong receipt_type in removeReceipt");
            }
          }

          this.receipt_income_list_state.splice(index, 1);
          break;
        }

        case RECEIPT_TYPE.DISBURSEMENT: {
          if (this.receipt_disbursement_list_state[index].isEdit) {
            this.delete_disbursement_receipt_ids.push(
              this.receipt_disbursement_list_state[index].receipt_id
            );
          }

          this.receipt_disbursement_list_state.splice(index, 1);
          break;
        }
        default:
          throw new Error("Wrong receipt_type in removeReceipt");
      }
    },
    validateFormData: function(formattedDisbursementList, formattedIncomeList, receiptCashList) {
      const isFormValid = this.$refs.form.validate();

      if (!isFormValid) {
        return "Vui lòng điền đầy đủ thông tin";
      }

      const totalDisbursementAmount = formattedDisbursementList.reduce(
        (acc, currentReceipt) => acc + (currentReceipt.amount || 0),
        0
      );
      const totalIncomeAmount = formattedIncomeList.reduce(
        (acc, currentReceipt) =>
          acc +
          (currentReceipt.collected_amount ||
            currentReceipt.deposit_amount ||
            0),
        0
      ) + receiptCashList.reduce(
        (acc, currentReceipt) =>
          acc +
          (currentReceipt.amount || 0),
        0
      );

      if (totalIncomeAmount === 0 && totalDisbursementAmount === 0) {
        return "Thiếu dữ liệu số tiền chi hoặc số tiền thu";
      }

      if (
        totalIncomeAmount - totalDisbursementAmount !==
        this.transaction.amount
      ) {
        return "Giá trị phiếu thu và chi không khớp với giá trị giao dịch ngân hàng";
      }

      for (let receipt of formattedIncomeList) {
        if (receipt.type === "receipt_room" && receipt.original_debt !== undefined && receipt.original_debt !== null) {
          if (receipt.collected_amount > receipt.original_debt + 200000) {
            return `Số tiền thu của phòng ${receipt.room_id || ''} không được vượt quá 200,000đ so với số tiền còn nợ`;
          }
        }
      }


      const indexReceiptRoomMissingData = formattedIncomeList.findIndex(
        (receipt) => receipt.receipt_type === ACCOUNT_TYPES.RECEIPT_ROOM && !receipt.room_state_id
      );

      const indexReturnDepositDisbursementMissingData = formattedDisbursementList.findIndex(
        (receipt) =>
          receipt.type === "return_deposit" &&
          (!receipt.building || !receipt.room_id)
      );

      if (indexReturnDepositDisbursementMissingData !== -1) {
        return `Phiếu chi ${indexReturnDepositDisbursementMissingData +
          1} thiếu dữ liệu số phòng hoặc tòa nhà`;
      }

      if (indexReceiptRoomMissingData !== -1) {
        return `Phiếu thu ${indexReceiptRoomMissingData +
          1} không có thông tin thu tiền`;
      }

      return "";
    },
    handleNextStep: async function() {
      this.loading.submit = true;
      const formattedDisbursementList = this.receipt_disbursement_list_state.map(
        (receipt) => {
          const { local_id, ...cleanedReceipt } = receipt;
          return {
            ...cleanedReceipt,
            amount: parseCurrency(receipt.amount),
            date_created: this.transaction.date_action,
          };
        }
      );

      const formattedIncomeList = this.receipt_income_list_state.filter(receipt => receipt.receipt_type !== "receipt_cash").map(
        (receipt) => {
          const { local_id, ...cleanedReceipt } = receipt;
          const collected_amount = parseCurrency(receipt.collected_amount) || 0;
          return {
            ...cleanedReceipt,
            date_collected: this.transaction.date_action,
            date_deposit: this.transaction.date_action,
            deposit_amount: parseCurrency(receipt.deposit_amount) || 0,
            collected_amount: collected_amount,
            // For receipt_room: set primary_amount = collected_amount if not set
            primary_amount: parseCurrency(receipt.primary_amount) || collected_amount,
            supplementary_amount: parseCurrency(receipt.supplementary_amount) || 0,
          };
        }
      );

      const receiptCashList = this.receipt_income_list_state.filter(receipt => receipt.receipt_type === "receipt_cash").map(
        (receipt) => {
          const { local_id, ...cleanedReceipt } = receipt;
          return {
            ...cleanedReceipt,
            type: receipt.receipt_type,
            amount: parseCurrency(receipt.collected_amount) || 0,
          };
        }
      );

      const errorMessage = this.validateFormData(
        formattedDisbursementList,
        formattedIncomeList,
        receiptCashList,
      );

      if (errorMessage) {
        swal.fire("Lỗi", errorMessage, "error");
        this.loading.submit = false;
        return;
      }

      // Phiếu ĐÃ LƯU mà bị đổi loại: bản ghi cũ nằm ở collection của loại cũ.
      // Đẩy mã phiếu gốc vào delete-list của loại CŨ, rồi gửi sang loại MỚI như một
      // bản ghi mới (bỏ _id/isEdit) để backend tạo mới thay vì đi nhánh sửa.
      formattedIncomeList.forEach((receipt) => {
        const original_type = receipt.original_receipt_type;

        if (!receipt.isEdit || !original_type) return;
        if (original_type === receipt.receipt_type) return;

        this.pushDeleteReceiptId(
          original_type,
          receipt.original_receipt_id || receipt.receipt_id
        );

        receipt.isEdit = false;
        delete receipt._id;
      });


      try {
        const promises = [];

        let description_computed = "";

        if (formattedDisbursementList.length || this.delete_disbursement_receipt_ids.length) {
          const filterExpenseOptions = this.EXPENSE_ACCOUNT_OPTIONS.filter(
            (item) => item.text !== "Chi lương (cũ)"
          );

          description_computed = formattedDisbursementList.reduce(
            (acc, currentReceipt) => {
              const foundExpenseOption = filterExpenseOptions.find(
                (item) => item.value === currentReceipt.type
              );

              return (
                acc +
                `${foundExpenseOption.text} ${currentReceipt.room_id ||
                  currentReceipt.loan_object || ""} ${currentReceipt.note || ""}; `
              );
            },
            ""
          );

          const receiptDisbursementPayload = {
            dataArray: formattedDisbursementList,
            transaction_id: this.transaction._id,
            delete_receipt_ids: this.delete_disbursement_receipt_ids,
          };

          promises.push(
            api.createOrEditDisbursements(receiptDisbursementPayload)
          );
        }

        const formattedReceiptOtherList = formattedIncomeList.filter(
          (receipt) => receipt.receipt_type === ACCOUNT_TYPES.RECEIPT_OTHER
        );

        const formattedReceiptLoanList = formattedIncomeList.filter(
          (receipt) => receipt.receipt_type === 'receipt_loan'
        );

        const formattedReceiptGamList = formattedIncomeList.filter(
          (receipt) => receipt.receipt_type === 'receipt_gam'
        );

        const formattedAdditionalDepositReceiptList = formattedIncomeList.filter(
          (receipt) => receipt.receipt_type === 'additional_deposit_receipt'
        );

        const formattedMrLongReceiptList = formattedIncomeList.filter(
          (receipt) => receipt.receipt_type === 'mr_long_receipt'
        );

        const formattedReceiptUndistributedEarningList = formattedIncomeList.filter(
          (receipt) => receipt.receipt_type === 'receipt_undistributed_earning'
        );

        if (formattedReceiptOtherList.length || this.delete_receipt_other_ids.length) {
          description_computed += formattedReceiptOtherList.reduce(
            (acc, currentReceipt) => acc + `Thu khác ${currentReceipt.note}; `,
            ""
          );

          // createOrEditReceiptOther
          const receiptOtherPayload = {
            dataArray: formattedReceiptOtherList,
            transaction_id: this.transaction._id,
            delete_receipt_ids: this.delete_receipt_other_ids,
          };

          promises.push(api.createOrEditReceiptOthers(receiptOtherPayload));
        }

        if (formattedAdditionalDepositReceiptList.length || this.delete_additional_deposit_receipt_ids.length) {
          description_computed += formattedAdditionalDepositReceiptList.reduce(
            (acc, currentReceipt) => acc + `Thu thêm tiền cọc ${currentReceipt.room_id} ${currentReceipt.note}; `,
            ""
          );

          // createOrEditAdditionalDepositReceipt
          const additionalDepositReceiptPayload = {
            dataArray: formattedAdditionalDepositReceiptList,
            transaction_id: this.transaction._id,
            delete_receipt_ids: this.delete_additional_deposit_receipt_ids,
          };

          promises.push(api.createOrEditAdditionalDepositReceipts(additionalDepositReceiptPayload));
        }

        if (formattedMrLongReceiptList.length || this.delete_mr_long_receipt_ids.length) {
          description_computed += formattedMrLongReceiptList.reduce(
            (acc, currentReceipt) => acc + `Thu tiền anh Long ${currentReceipt.note}; `,
            ""
          );

          const payload = {
            dataArray: formattedMrLongReceiptList,
            transaction_id: this.transaction._id,
            delete_receipt_ids: this.delete_mr_long_receipt_ids,
          };

          promises.push(api.createOrEditMrLongReceipts(payload));
        }

        const formattedReceiptRoomList = formattedIncomeList.filter(
          (receipt) => receipt.receipt_type === ACCOUNT_TYPES.RECEIPT_ROOM
        );

        if (formattedReceiptRoomList.length || this.delete_receipt_room_ids.length) {
          description_computed += formattedReceiptRoomList.reduce(
            (acc, currentReceipt) =>
              acc + `Thu tiền phòng ${currentReceipt.room_id}; `,
            ""
          );

          // createOrEditReceiptRoom
          const receiptRoomPayload = {
            dataArray: formattedReceiptRoomList,
            transaction_id: this.transaction._id,
            delete_receipt_ids: this.delete_receipt_room_ids,
          };

          promises.push(api.createOrEditReceiptRooms(receiptRoomPayload));
        }

        const formattedReceiptDepositList = formattedIncomeList.filter(
          (receipt) => receipt.receipt_type === "receipt_deposit"
        );

        if (formattedReceiptDepositList.length) {
          description_computed += formattedReceiptDepositList.reduce(
            (acc, currentReceipt) =>
              acc + `Thu tiền cọc ${currentReceipt.room_id}; `,
            ""
          );
          // createOrEditReceiptDeposit
          formattedReceiptDepositList.forEach((receipt) => {
            const postData = {
              ...receipt,
              room_price_old: parseCurrency(receipt.room_price_old) || 0,
              room_price: parseCurrency(receipt.room_price) || 0,
              deposit_price: parseCurrency(receipt.deposit_price) || 0,
              deposit_price_old: parseCurrency(receipt.deposit_price_old) || 0,
              deposit_amount: parseCurrency(receipt.deposit_amount) || 0,
              date_schedule_in: new Date(receipt.date_schedule_in),
              date_deposit: new Date(this.transaction.date_action),
              agent_id: receipt.agent && receipt.agent.user_id,
              agent_name:
                receipt.agent && (receipt.agent.name || receipt.agent.username),
              transaction_id: this.transaction._id,
            };


            if (receipt.isEdit) {
              promises.push(
                api.updateReceipt(`/deposits/${receipt._id}`, postData)
              );
            } else {
              promises.push(api.createDepositReceipt(postData));
            }
          });
        }

        if (receiptCashList.length) {
          const linkBankTransactionWithReceiptCashPayload = {
            list_receipts: receiptCashList,
            bank_transaction: this.transaction,
          };

          description_computed += receiptCashList.reduce(
            (acc, currentReceipt) => acc + `Thu tiền mặt ${currentReceipt.building} ${currentReceipt.note}; `,
            ""
          );

          promises.push(
            api.linkBankTransactionWithReceiptCash(linkBankTransactionWithReceiptCashPayload)
          );
        }

        if (formattedReceiptLoanList.length || this.delete_receipt_loan_ids.length) {
          description_computed += formattedReceiptLoanList.reduce(
            (acc, currentReceipt) => acc + `Thu tiền đi vay đối tượng ${currentReceipt.loan_object} ${currentReceipt.note}; `,
            ""
          );

          // createOrEditReceiptLoan
          const receiptLoanPayload = {
            dataArray: formattedReceiptLoanList,
            transaction_id: this.transaction._id,
            delete_receipt_ids: this.delete_receipt_loan_ids,
          };
          promises.push(api.createOrEditReceiptLoans(receiptLoanPayload));
        }

        if (formattedReceiptGamList.length || this.delete_receipt_gam_ids.length) {
          description_computed += formattedReceiptGamList.reduce(
            (acc, currentReceipt) => acc + `Thu công nợ cô Gấm ${currentReceipt.note}; `,
            ""
          );

          // createOrEditReceiptGams
          const receiptGamPayload = {
            dataArray: formattedReceiptGamList,
            transaction_id: this.transaction._id,
            delete_receipt_ids: this.delete_receipt_gam_ids,
          };
          promises.push(api.createOrEditReceiptGams(receiptGamPayload));
        }

        if (formattedReceiptUndistributedEarningList.length || this.delete_receipt_undistributed_earning_ids.length) {
          description_computed += formattedReceiptUndistributedEarningList.reduce(
            (acc, currentReceipt) => acc + `Thu lợi nhuận chưa phân phối ${currentReceipt.note}; `,
            ""
          );

          const receiptUndistributedEarningPayload = {
            dataArray: formattedReceiptUndistributedEarningList,
            transaction_id: this.transaction._id,
            delete_receipt_ids: this.delete_receipt_undistributed_earning_ids,
          };

          promises.push(api.createOrEditReceiptUndistributedEarnings(receiptUndistributedEarningPayload));
        }

        // delete deposit
        const deleteDepositPromises = [];
        this.delete_receipt_deposit_ids.forEach((receipt_id) => {
            const postData = {
              receipt_id,
            };

            deleteDepositPromises.push(api.deleteDeposit(postData));
          });

        const deleteDepositResults = await Promise.all(deleteDepositPromises);

        deleteDepositResults.forEach((result) => {
          if (result.status !== 200) {
            throw new Error(result.message);
          }
        });

        // Create or edit receipts
        const results = await Promise.all(promises);

        results.forEach((result) => {
          if (result.status !== 200) {
            throw new Error(result.message);
          }
        });

        description_computed = description_computed
          .trim() // Remove leading/trailing spaces
          .replace(/undefined/g, "") // Remove undefined
          .replace(/ \;/g, ";") // Replace " ;" with ";"
          .replace(/\s{2,}/g, " ") // Replace double or more spaces with a single space
          .replace(/;$/, ''); // Remove trailing semicolon

        this.transaction.description = description_computed;

        await api.updateBankTransaction(this.transaction._id, {
          description_computed,
        });

        swal.fire("Thành công", "Thành công", "success");
        this.dialog_detail_state = false;
        this.$emit("reloadTable");
        this.$emit("update:dialogDetail", false);
      } catch (e) {
        // Các request ở trên chạy SONG SONG và không atomic: khi một request lỗi thì
        // những request khác đã ghi dữ liệu xong. Nếu giữ nguyên state cũ, người dùng
        // bấm Lưu lại sẽ tạo TRÙNG toàn bộ phiếu đã ghi thành công (NT-250).
        // Vì vậy phải nạp lại giao dịch từ server để các phiếu đã tạo mang _id/isEdit,
        // lần lưu sau trở thành UPDATE thay vì INSERT.
        this.$emit("reloadTable");

        swal.fire(
          "Lỗi",
          `${e.message}\n\nMột số phiếu có thể đã được lưu. Danh sách đã được nạp lại từ hệ thống, vui lòng kiểm tra trước khi lưu tiếp.`,
          "error"
        );
      } finally {
        this.loading.submit = false;
      }
    },
    setReceiptListState: function(receipt_type, receipt, index) {
      switch (receipt_type) {
        case RECEIPT_TYPE.INCOME: {
          this.receipt_income_list_state[index] = receipt;
          break;
        }
        case RECEIPT_TYPE.DISBURSEMENT: {
          this.receipt_disbursement_list_state[index] = receipt;
          break;
        }
        default:
          throw new Error("Wrong receipt_type in setReceiptListState");
      }
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 80%;
  max-width: 800px;
}
th {
  padding: 8px;
  border-bottom: 1px solid #ddd;
}
td {
  padding: 6px;
}
.cell-fit {
  width: 1%;
  white-space: nowrap;
}
.border-top {
  padding-top: 9px;
  border-top: 1px solid #ddd;
}
.hightlight-row {
  background-color: #ddfbe6;
}
</style>
